var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';
import Title from '../../atoms/Title';
import { VerticalGap } from '../../atoms/Gap/Gap';
import { checkBirthDate, checkEmail, checkEmailDuplicatePassed, checkGender, checkName, checkNewPassword, checkPhoneAuth, checkTermsAgreement, getBrandByLocation, getCountriesInfo, makeOptionListFromCountriesInfo, validateEmail, } from '../../../businessLogics';
import { noBirthDateAtom, readWriteModalHistoryAtom } from '../../../stores';
import { useAtom } from 'jotai';
import Desc from '../../atoms/Desc';
import Form from '../../templates/Form';
import Input from '../../atoms/Input';
import NewPasswordForm from '../../molecules/NewPasswordForm/NewPasswordForm';
import PhoneAuthenticationForm from '../../molecules/PhoneAuthenticationForm/PhoneAuthenticationForm';
import styled from '@emotion/styled';
import { additional, hanghae, neutralDay, scc } from '@teamsparta/design-system';
import AgreeTerms from '../../molecules/AgreeTerms/AgreeTerms';
import { Genders, initialTermsAgreement } from '../../../models';
import ChooseOne from '../../molecules/ChooseOne/ChooseOne';
import CtaBtn from '../../atoms/CtaBtn';
import AlertText from '../../atoms/AlertText';
import RequestBtn from '../../atoms/RequestBtn';
import { MainContents } from '../../../styles/_common.style';
import { useIsMobile, useQueryStringParams } from '../../../businessLogics/hooks';
import { getIsEmailDuplicate, useSignupEmail } from '../../../businessLogics/apis';
import LoadingSpinner from '../../atoms/Spinner';
import { sendLog } from '../../../logging';
var SignupEmail = function (_a) {
    var setIsShow = _a.setIsShow, nextPage = _a.nextPage, CPLogger = _a.CPLogger;
    var options = makeOptionListFromCountriesInfo(getCountriesInfo());
    var _b = useAtom(readWriteModalHistoryAtom), updateHistory = _b[1];
    var _c = useAtom(noBirthDateAtom), noBirthDate = _c[0], setNoBirthDate = _c[1];
    var _d = useState(''), email = _d[0], setEmail = _d[1];
    var _e = useState(false), showEmailDuplicateCheckRequestBtn = _e[0], setShowEmailDuplicateCheckRequestBtn = _e[1];
    var _f = useState(false), isEmailDuplicateCheckRequestSendable = _f[0], setIsEmailDuplicateCheckRequestSendable = _f[1];
    var _g = useState(false), isEmailDuplicateCheckPassed = _g[0], setIsEmailDuplicateCheckPassed = _g[1];
    var _h = useState(''), password = _h[0], setPassword = _h[1];
    var _j = useState(''), passwordDoubleCheck = _j[0], setPasswordDoubleCheck = _j[1];
    var _k = useState(options.find(function (option) { return option.key === '82'; })), countryCode = _k[0], setCountryCode = _k[1];
    var _l = useState(''), phoneNumber = _l[0], setPhoneNumber = _l[1];
    var _m = useState(false), isPhoneAuthPassed = _m[0], setIsPhoneAuthPassed = _m[1];
    var _o = useState(''), name = _o[0], setName = _o[1];
    var _p = useState(noBirthDate ? '19970101' : ''), birthday = _p[0], setBirthday = _p[1];
    var _q = useState(null), gender = _q[0], setGender = _q[1];
    var _r = useState(initialTermsAgreement), termsAgreement = _r[0], setTermsAgreement = _r[1];
    var _s = useState(null), emailWarning = _s[0], setEmailWarning = _s[1];
    var _t = useState(null), passwordWarning = _t[0], setPasswordWarning = _t[1];
    var _u = useState(null), nameWarning = _u[0], setNameWarning = _u[1];
    var _v = useState(null), birthdayWarning = _v[0], setBirthdayWarning = _v[1];
    var _w = useState(null), kkoId = _w[0], setKkoId = _w[1];
    var _x = useState(null), current = _x[0], setCurrent = _x[1];
    var _y = useState(false), isAllFieldsOk = _y[0], setIsAllFieldsOk = _y[1];
    var _z = useState(false), isButtonDisabled = _z[0], setIsButtonDisabled = _z[1];
    var isMobile = useIsMobile();
    var query = useQueryStringParams();
    useEffect(function () {
        sendLog('signup_email_view', CPLogger, { brand: getBrandByLocation() });
    }, []);
    useEffect(function () {
        if (query.get('kko_id'))
            setKkoId(Number(query.get('kko_id')));
        if (query.get('current'))
            setCurrent(query.get('current'));
    }, [query]);
    useEffect(function () {
        setIsAllFieldsOk([
            checkEmail(email),
            checkEmailDuplicatePassed(isEmailDuplicateCheckPassed),
            checkNewPassword(password, passwordDoubleCheck),
            checkName(name),
            checkPhoneAuth(isPhoneAuthPassed),
            checkBirthDate(birthday),
            checkGender(gender),
            checkTermsAgreement(termsAgreement),
        ].every(function (value) { return value; }));
    }, [email, password, passwordDoubleCheck, name, countryCode, phoneNumber, birthday, gender, termsAgreement]);
    useEffect(function () {
        setIsEmailDuplicateCheckPassed(false);
        if (email.length > 0) {
            setShowEmailDuplicateCheckRequestBtn(true);
        }
        else {
            setShowEmailDuplicateCheckRequestBtn(false);
        }
        if (validateEmail(email)) {
            setIsEmailDuplicateCheckRequestSendable(true);
            setEmailWarning(null);
        }
        else {
            setIsEmailDuplicateCheckRequestSendable(false);
        }
    }, [email]);
    var requestEmailDuplicateCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isEmailDuplicated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getIsEmailDuplicate(email)];
                case 1:
                    isEmailDuplicated = _a.sent();
                    if (isEmailDuplicated.ok) {
                        if (!isEmailDuplicated.is_exist) {
                            if (isEmailDuplicated.is_kko_exist) {
                                setEmailWarning('카카오 계정으로 가입한 이메일입니다.');
                            }
                            else {
                                setIsEmailDuplicateCheckRequestSendable(false);
                                setIsEmailDuplicateCheckPassed(true);
                            }
                        }
                        else {
                            setEmailWarning('이미 사용 중인 이메일입니다.');
                        }
                    }
                    return [2];
            }
        });
    }); };
    var showEmailWarning = function () {
        return checkEmail(email, setEmailWarning) && checkEmailDuplicatePassed(isEmailDuplicateCheckPassed, setEmailWarning);
    };
    var showPasswordWarning = function () { return checkNewPassword(password, passwordDoubleCheck, setPasswordWarning); };
    var showNameWarning = function () { return checkName(name, setNameWarning); };
    var showBirthdayWarning = function () { return checkBirthDate(birthday, setBirthdayWarning); };
    var ctaButton = function (isButtonDisabled) {
        return (_jsx(_Fragment, { children: _jsx(CtaBtn, __assign({ bgColor: isAllFieldsOk && !isButtonDisabled ? scc.red100 : '#e8344e4d', color: neutralDay.white, isInactive: !isAllFieldsOk || isButtonDisabled, onClickAction: isButtonDisabled
                    ? function (e) {
                        e.stopPropagation();
                    }
                    : throttledSignUp }, { children: isButtonDisabled ? (_jsx(LoadingSpinner, { src: "".concat(process.env.REACT_APP_CDN_LOGIN_URL, "/loading.png") })) : ('가입하기') })) }));
    };
    var signUpRequest = useSignupEmail(setIsShow, setIsButtonDisabled, CPLogger, nextPage);
    var signUp = function () {
        if (checkEmail(email, setEmailWarning) &&
            checkEmailDuplicatePassed(isEmailDuplicateCheckPassed, setEmailWarning) &&
            checkNewPassword(password, passwordDoubleCheck, setPasswordWarning) &&
            checkName(name, setNameWarning) &&
            checkBirthDate(birthday, setBirthdayWarning) &&
            checkPhoneAuth(isPhoneAuthPassed) &&
            checkGender(gender) &&
            checkTermsAgreement(termsAgreement)) {
            signUpRequest.mutate({
                name: name,
                email: email,
                password: password,
                phone: phoneNumber,
                countryCode: countryCode.key,
                gender: (gender === null || gender === void 0 ? void 0 : gender.key) || 'undefined',
                birthday: birthday,
                marketingAgreement: termsAgreement['marketing'],
                kkoId: kkoId,
                current: current !== null && current !== void 0 ? current : window.location.href,
            });
        }
        else {
            alert('모든 정보를 입력해주세요.');
        }
    };
    var throttledSignUp = throttle(signUp, 200, { trailing: false }, [
        email,
        password,
        name,
        phoneNumber,
        birthday,
        termsAgreement,
    ]);
    return (_jsx(_Fragment, { children: _jsxs(MainContents, __assign({ isCenterInMobile: true, paddingTop: 60 }, { children: [_jsxs(Title, { children: ["\uD558\uB098\uC758 \uACC4\uC815\uC73C\uB85C", _jsx("br", {}), "\uB354\uC6B1 \uAC04\uD3B8\uD558\uAC8C"] }), _jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsxs(Desc, { children: ["\uC2A4\uD30C\uB974\uD0C0\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uC11C\uBE44\uC2A4\uB97C", _jsx("br", {}), "\uD558\uB098\uC758 \uACC4\uC815\uC73C\uB85C \uBAA8\uB450 \uC774\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694."] }), _jsx(VerticalGap, { size: 20 }), _jsx(Logos, { src: "".concat(process.env.REACT_APP_CDN_LOGIN_URL, "/logos.png") }), _jsx(VerticalGap, { size: 60 }), _jsxs(Form, __assign({ label: '이메일', checkAlert: showEmailWarning, hasSingleChild: true }, { children: [_jsx(Input, { value: email, setValue: setEmail, placeHolder: '이메일 입력', isEmbedded: true, isWithButton: true, isSingleChild: true }), _jsx(RequestBtn, { isShow: showEmailDuplicateCheckRequestBtn && !isEmailDuplicateCheckPassed, isActive: isEmailDuplicateCheckRequestSendable, requestFunction: requestEmailDuplicateCheck, btnText: '중복 확인' })] })), _jsx(AlertText, __assign({ isShow: isEmailDuplicateCheckPassed || !!emailWarning, color: isEmailDuplicateCheckPassed ? additional.green100 : hanghae.red100 }, { children: isEmailDuplicateCheckPassed ? '사용 가능한 이메일입니다.' : emailWarning })), _jsx(VerticalGap, { size: 20 }), _jsx(NewPasswordForm, { label: '비밀번호', password: password, setPassword: setPassword, passwordDoubleCheck: passwordDoubleCheck, setPasswordDoubleCheck: setPasswordDoubleCheck, passwordWarning: passwordWarning, checkAlert: showPasswordWarning }), _jsx(VerticalGap, { size: 20 }), _jsx(Form, __assign({ label: '이름', checkAlert: showNameWarning, hasSingleChild: true }, { children: _jsx(Input, { value: name, setValue: setName, placeHolder: '이름 입력', isEmbedded: true, isSingleChild: true }) })), _jsx(AlertText, __assign({ isShow: !!nameWarning, color: hanghae.red100 }, { children: nameWarning })), _jsx(VerticalGap, { size: 20 }), _jsx(PhoneAuthenticationForm, { label: '휴대폰 번호', countryCode: countryCode, setCountryCode: setCountryCode, phoneNumber: phoneNumber, setPhoneNumber: setPhoneNumber, isAuthentic: isPhoneAuthPassed, setIsAuthentic: setIsPhoneAuthPassed, isCheckAlertNeeded: true }), _jsx(VerticalGap, { size: 20 }), !noBirthDate && (_jsxs(_Fragment, { children: [_jsx(Form, __assign({ label: '생년월일', nudge: '생일에 엄청난 일이 벌어질지도 몰라요!', checkAlert: showBirthdayWarning, hasSingleChild: true }, { children: _jsx(Input, { value: birthday, setValue: setBirthday, placeHolder: 'ex. 19990101', isEmbedded: true, maxLength: 8, type: 'number', isSingleChild: true }) })), _jsx(AlertText, __assign({ isShow: !!birthdayWarning, color: hanghae.red100 }, { children: birthdayWarning })), _jsx(VerticalGap, { size: 32 })] })), _jsx(ChooseOne, { label: '성별', optionList: Genders, selectedOption: gender, setSelectedOption: setGender }), _jsx(VerticalGap, { size: 40 }), _jsx(Divider, {}), _jsx(VerticalGap, { size: 40 }), _jsx(AgreeTerms, { agreements: termsAgreement, updateAgreements: setTermsAgreement }), _jsx(VerticalGap, { size: 40 }), ctaButton(isButtonDisabled)] })) }));
};
export default SignupEmail;
var RowContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  justify-content: space-between;\n"])));
var Divider = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  background: ", ";\n"], ["\n  width: 100%;\n  height: 1px;\n  background: ", ";\n"])), neutralDay.gray10);
var Logos = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 248px;\n  object-fit: contain;\n"], ["\n  width: 248px;\n  object-fit: contain;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SignupEmail.js.map